import React from "react";

import Impressum from "./Impressum";
import Datenschutz from "./Datenschutz";

import CheckedIDLink from "../../misc/routing/CheckedIDLink";
import LabelIconButton from "../../misc/buttons/LabelIconButton";

import { FaRegAddressCard } from "react-icons/fa";
import { FaPhoneAlt } from "react-icons/fa";
import { FaRegEnvelope } from "react-icons/fa";
import { FaRoute } from "react-icons/fa";
import { FaRegCopyright } from "react-icons/fa";
import { FaUserLock } from "react-icons/fa";

const AboutSlideThree = ({ allRooms }) => {
  const [openImpressum, setOpenImpressum] = React.useState(false);
  const [openDatenschutz, setOpenDatenschutz] = React.useState(false);

  return (
    <div>
      <div className="swiper-slide-section">
        <h2 className="highlighted">Ansprechpartner</h2>

        <div className="icon-text-container">
          <FaRegAddressCard />
          <p>
            {/* TODO: Link path needs to be redone with the right roomId */}
            <CheckedIDLink
              allRooms={allRooms}
              roomIDToCheck="-"
              errorText="Ungeklärt"
            />
          </p>
        </div>

        <div className="icon-text-container">
          <FaPhoneAlt />
          <a href="tel:0941 943-4444">0941 943-4444</a>
        </div>

        <div className="icon-text-container">
          <FaRegEnvelope />
          <a href="mailto:support@ur.de" target={"_blank"} rel="noreferrer">
            support@ur.de
          </a>
        </div>

        <div className="icon-text-container">
          <FaRoute />
          <a
            href="https://urwalking.ur.de/navi/?dest=%5B79,1,PT%5D&v=ur"
            target={"_blank"}
            rel="noreferrer"
          >
            Wegführung über UR.Walking
          </a>
        </div>
      </div>
      <div className="swiper-slide-section">
        <h2 className="highlighted">Rechtliches</h2>
        <LabelIconButton
          className="full-width small-shadow"
          indicatorIcon={<FaRegCopyright />}
          display_text="Impressum"
          value="Impressum"
          onClickLabel={() => setOpenImpressum(true)}
        />

        <LabelIconButton
          className="full-width small-shadow"
          indicatorIcon={<FaUserLock />}
          display_text="Datenschutzerklärung"
          value="Datenschutzerklärung"
          onClickLabel={() => setOpenDatenschutz(true)}
        />

        <Impressum
          openImpressum={openImpressum}
          handleCloseImpressum={() => setOpenImpressum(false)}
          backdropImpressum={"static"}
        />

        <Datenschutz
          openDatenschutz={openDatenschutz}
          handleCloseDatenschutz={() => setOpenDatenschutz(false)}
          backdropDatenschutz={"static"}
        />
      </div>
    </div>
  );
};

export default AboutSlideThree;
